export default __webpack_public_path__ + "static/media/models.cf582e56.jpg";